import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';

function ProtectedRoute({ children }) {
    const location = useLocation();
    const [status, setStatus] = useState('checking');
    const API_URL = process.env.REACT_APP_API_URL || '';

    useEffect(() => {
        window.history.scrollRestoration = 'manual';

        let cancelled = false;

        const verifySession = async () => {
            try {
                const res = await fetch(`${API_URL}/api/auth/me`, { credentials: 'include' });
                if (!res.ok) {
                    localStorage.removeItem('userSession');
                    if (!cancelled) setStatus('unauthenticated');
                    return;
                }

                const data = await res.json();
                if (!data?.success || !data.user) {
                    localStorage.removeItem('userSession');
                    if (!cancelled) setStatus('unauthenticated');
                    return;
                }

                const existingSession = JSON.parse(localStorage.getItem('userSession') || '{}');
                const refreshedSession = {
                    userId: data.user.id,
                    phone: data.user.phone,
                    pan: data.user.pan_number,
                    name: data.user.name,
                    role: data.user.role,
                    loginTime: Date.now(),
                    expiresAt: data.expiresAt || (Date.now() + 30 * 60 * 1000),
                    clientId: data.user.client_id,
                    token: data.token || existingSession.token || ''
                };
                localStorage.setItem('userSession', JSON.stringify(refreshedSession));
                window.dispatchEvent(new CustomEvent('userSessionChanged', {
                    detail: refreshedSession
                }));

                if (!cancelled) setStatus('authenticated');
            } catch (e) {
                localStorage.removeItem('userSession');
                if (!cancelled) setStatus('unauthenticated');
            }
        };

        verifySession();

        const handlePageShow = (event) => {
            if (event.persisted) verifySession();
        };

        window.addEventListener('pageshow', handlePageShow);

        return () => {
            cancelled = true;
            window.removeEventListener('pageshow', handlePageShow);
        };
    }, [API_URL, location.pathname]);

    if (status === 'checking') {
        return null;
    }

    if (status === 'unauthenticated') {
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default ProtectedRoute;
